import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoModificationBloc from "../../blocs/retirement/post-signature/REInfoModificationBloc";


export default function REInfoModificationPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
     
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Page de modification</h1>
        <div ref={pageGapRef} className="page-gap"></div>
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <REInfoModificationBloc/>
        </div>
      </div>
   
    )

}